const onRowClick = (navigate, row) => {
  if (row?.original?.deliveryId) {
    navigate(`/admin/uploads/${row.original.deliveryId}`);
  }
};

export default onRowClick;
